namespace TabAurous.Finance {

    @Serenity.Decorators.registerEditor()
    export class JournalDetailModesEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addOption("Cash", "Cash");
            this.addOption("Cheque", "Cheque");

        }
    }
}